<div class="p-grid">
  <div class="p-col quality-assurance" *ngIf="fields$ | async as fields">
    <app-qa-check-list-in-setup [fields]="fields" (formValid)="onFormValidityChange($event)"></app-qa-check-list-in-setup>
  </div>
</div>
